/**
 * i18next init for unity/base Vite SPA.
 * Replaces next-intl (ADR-020, E32 T-3902).
 */

import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

import enUS from '@/locales/en-US.json'
import es419 from '@/locales/es-419.json'

const RTL_LOCALES = new Set(['ar', 'he', 'fa', 'ur'])

export function getDirection(locale: string): 'rtl' | 'ltr' {
  return RTL_LOCALES.has(locale.split('-')[0] ?? locale) ? 'rtl' : 'ltr'
}

i18n
  .use(initReactI18next)
  .init({
    defaultNS: 'common',
    lng: 'en-US',
    fallbackLng: 'en-US',
    resources: {
      'en-US': { common: enUS },
      'es-419': { common: es419 },
    },
    interpolation: { escapeValue: false },
  })
  .catch(() => {
    // i18n failure is non-fatal; app renders with key strings
  })

export default i18n
